import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";

import DeploymentRow from "components/View/Rows/DeploymentRow";

import DeploymentTile from "components/Tiles/DeploymentTile";

import { isEnabled } from "utils/featureFlags";

class DeploymentItem extends React.PureComponent {
  handleClick(data, viewMode) {
    const { openDeployment, fetchRun, resetSearch, onClick, history } = this.props;

    if (isEnabled("aible-next") || true) {
      return history.push("/next/" + data.datasetId + "/" + data?.nextId);
    }

    if (isEnabled("aible-consumer")) {
      return this.props.history.push("collaborate/" + data.project_id);
    }

    if (onClick) {
      return onClick();
    }
    fetchRun();

    resetSearch && resetSearch();

    return openDeployment(data, viewMode);
  }

  renderTile(data) {
    const {
      index,
      isHighlight,
      updateHoverDataset,
      noClick,
      isSmall,
      handleDelete,
      handleCancel,
      onHover,
      style,
      deployRecipeId,
      handleDeployRecipe,
      hasDeployedRecipe,
      deployedRecipeName,
      shouldHighlight,
      onClick,
      handleTerminateRecipeDeployment,
      hideDelete,
      monitor,
      job,
      noPermissions,
      isConsumer
    } = this.props;

    const retOnClick = onClick
      ? () => onClick(data.project_id)
      : noClick
        ? undefined
        : (event, viewMode) => this.handleClick(data, viewMode);
    const retHandleDelete = noClick ? undefined : () => handleDelete(data.id, data.modelgroup_id ? true : false);

    return (
      <div style={style} key={index}>
        {
          <DeploymentTile
            job={job}
            deployRecipeId={deployRecipeId}
            deployment={data}
            // handleDelete={retHandleDelete}
            onClick={retOnClick}
            isHighlight={isHighlight}
            isSmall={isSmall}
            onHover={(id) => onHover(id)}
            handleDeployRecipe={handleDeployRecipe}
            hasDeployedRecipe={hasDeployedRecipe}
            deployedRecipeName={deployedRecipeName}
            handleTerminateRecipeDeployment={handleTerminateRecipeDeployment}
            monitor={monitor}
            noPermissions={noPermissions}
            shouldHighlight={shouldHighlight}
            hideDelete={hideDelete}
            isConsumer={isConsumer}
          />
        }
      </div>
    );
  }

  renderRow(data) {
    const { index, isHighlight, job, noPermissions } = this.props;

    return (
      <DeploymentRow
        job={job}
        deployment={data}
        onClick={() => this.handleClick(data)}
        isHighlight={isHighlight}
        key={index}
        noPermissions={noPermissions}
      />
    );
  }

  render() {
    const { isTile, data } = this.props;

    return isTile ? this.renderTile(data) : this.renderRow(data);
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleDelete: (deployId, isGroup = false) => dispatch(deploymentsReducer.stopDeploy(deployId, isGroup)),
  handleCancel: (deployId) => dispatch(deploymentsReducer.cancelDeploy(deployId)),

  openDeployment: (deployment, viewMode) => dispatch(deploymentsReducer.openDeploy(deployment, viewMode)),

  onHover: (id) => dispatch(globalReducer.updateHover(id, "RUNID")),
  handleDeployRecipe: (deployId) => dispatch(recipeReducer.deployRecipe(ownProps.deployRecipeId, deployId)),
  handleTerminateRecipeDeployment: (deployId) => dispatch(recipeReducer.terminateRecipeDeployment(deployId)),
  fetchRun: () => {
    dispatch(runReducer.fetchRun(ownProps.data && ownProps.data.job_id));
  },
  resetSearch: () => dispatch(viewReducer.updateSearch(undefined))
});

const mapStateToProps = (state, ownProps) => {
  const hoverItem = globalReducer.getHoverItem(state);
  const data = ownProps.data ? ownProps.data : deploymentsReducer.getProjectDeployment(state, ownProps.id);
  let job = null;
  if (data && data.job_id) {
    job = runReducer.getJob(state, data.job_id);
  }

  const projectId = data && data.project_id;

  return {
    job: job,
    data: data,
    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),
    type: viewReducer.getType(state),
    isHighlight: hoverItem && ownProps.data && hoverItem.hoverType === "RUN" && hoverItem.id === ownProps.data.job_id,

    hasDeployedRecipe: recipeReducer.hasAnyDeployedRecipes(state, data && data.id),
    deployedRecipeName: recipeReducer.getRecipeName(state, ownProps.deployRecipeId),
    noPermissions: projectId && projectReducer.getSegmentCount(state, projectId) === 0
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DeploymentItem);
